export const SlaStatusMessages = {
  'en-US': {
    slaStatuses: {
      AwaitingInventoryAllocation: 'Estimated fulfillment date not set - awaiting inventory allocation',
      AwaitingReset: 'Estimated fulfillment date not set - awaiting reset',
      Unavailable: 'Estimated fulfillment date unavailable on shipments created prior to 07/07/2020',
      PendingOnTime: 'Pending - within estimate',
      FulfilledOnTime: 'Fulfilled on time',
      PendingLate: 'Pending late',
      FulfilledLate: 'Fulfilled late'
    },
    slaStatusesCompact: {
      AwaitingInventoryAllocation: 'Awaiting Inventory Allocation',
      AwaitingReset: 'Awaiting Reset',
      Unavailable: 'Unavailable',
      PendingOnTime: 'Pending On Time',
      FulfilledOnTime: 'Fulfilled On Time',
      PendingLate: 'Pending Late',
      FulfilledLate: 'Fulfilled Late'
    },
    slaStatusShorthand: {
      AwaitingInventoryAllocation: 'Unavailable',
      AwaitingReset: 'Unavailable',
      Unavailable: 'Unavailable',
      PendingOnTime: 'Pending',
      FulfilledOnTime: 'On Time',
      PendingLate: 'Late',
      FulfilledLate: 'Late'
    }
  }
}
